import React, { useState } from 'react';
import DateSelect from '../../../../UI/Inputs/DateSelect';
import cl from './SenderAt.module.css';

const SenderAt = ({ carService, ValuePar, CarID }) => {
    const carResetData = {
        car_id: CarID,
        sender_at: ValuePar,
    };

    const [newCar, setNewCar] = useState(carResetData);

    const onChangeDate = (date) => {
        const updatedCar = {
            ...newCar,
            sender_at: date ? date : "",
        }; 
        
        if (date === ""){
            return
        }
        
        if (date === ValuePar){
            return
        } 
        setNewCar(updatedCar); 
        carService.updateSenderAt(updatedCar);
    };

    return (
        <>
            <div className={cl.groupInput +' ' + 'centreddate'}>
                <DateSelect
                    defDate={newCar.sender_at}
                    onChange={onChangeDate}
                    placeholderText=""
                    popperClassName={cl.dataContainer}
                    wrapperClassName={cl.dataContainer}
                    className={cl.input} 

                /> 
            </div>
        </>
    );
};

export default SenderAt;
